module.exports = __webpack_public_path__ + "img/no.9c79e753.png";